
import { i18nText } from '@/locales';

import {Component, Prop} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {mixins} from "vue-class-component";
import {DisplayMasks} from "@/UI/mixins/DisplayMasks";
import {ClientsMix} from "@/UI/mixins/ClientsMix";
import {ISalonsListItem} from "@/entity/salons/salons.types";
import {FiltersData} from "@/entity/filters/extFilter";
import {TableColumns as ClientColumns} from "@/UI/pages/clients/lib/table";
import moment from "moment";
import {Vue} from "vue-property-decorator";
import {TableColumns} from "@/UI/pages/salons/lib/table";
import {ProxyGetData} from "../Helpers/getData";
import FilterTableComponent from "@/UI/components/Helpers/filterAndSorted/FilterTableComponent.vue";
import {ClientCategoryStore} from "@/store/modules/ClientsCategory";
import {getStudioId} from "@/UI/lib/state";
import {appFiltersStore} from "@/store/modules/appFilters";
import {appPaginationStore} from "@/store/modules/appPagination";


@Component({
  components: {
    FilterTableComponent,
    PageTitle,
  },
})
export default class SalonClients extends mixins(
  ProxyGetData,
  DisplayMasks,
  ClientsMix,
  TableColumns,
  ClientColumns,
) {
  @Prop() readonly salon!: ISalonsListItem;

  filtersData = new FiltersData();

  async clearInput(val: any) {
    if (val.dataIndex === "name") await this.filterData({name: "0"});
    if (val.dataIndex === "phone") await this.filterData({phone: "0"});
    await this.getData();
    await this.sortedData("desc", {dataIndex: "created_at"});
    this.disabled_sort = true;
  }

  async handleSearchfromHead(selectedKeys: any, confirm: any, dataIndex: any): Promise<void> {
    if (dataIndex === "name") await this.filterData({name: selectedKeys[0]});
    if (dataIndex === "phone") await this.filterData({phone: selectedKeys[0]});
    await this.getData();
    this.disabled_sort = false;
  }

  dateReg(record: any) {
    return moment(record).format("DD.MM.YYYY");
  }

  filtersCallback(filter: Array<Record<string, any>>): void {
    this.onApplyFilters();
  }
  async created(): Promise<void> {
    if (!this.formReady) {
      try {
        this.proxyFilter = {
          salon_id: getStudioId(this),
        };
        appPaginationStore.setCurrent(1);
        await this.sortedData("desc", {dataIndex: "created_at"});
        await ClientCategoryStore.fetchAll();
        this.setFilters(this);
      } catch (e) {
        console.log(e);
      } finally {
        this.formReady = true;
      }
    }
  }

  setFilters(that: any): void {
    this.filtersData.filters.push(
      {
        key: 0,
        type: "select",
        label: i18nText("Пол"),
        defaultValue: 0,
        default_value: [i18nText("Не указано")],
        placeholder: "",
        value: [
          {
            label: i18nText("Не указано"),
            key: "0",
          },
          {
            label: i18nText("Мужской"),
            key: "1",
          },
          {
            label: i18nText("Женский"),
            key: "2",
          },
        ],
        fieldNames: ["active"],
        filtered: false,
        async onChange(value: any) {
          let filter = {}

          if (Number(value)) {
            filter = {
              sex: value,
            }
          } else {
            filter = {sex: "0"}
          }
          console.log("FILTER", filter)
          await that.filterData(filter)
        },
      },
      {
        key: 1,
        type: "range-input",
        label: i18nText("Продано, ₽"),
        async okRange(key1: any, key2: any) {
          let filter = {}
          filter = {
            sold_from: key1,
            sold_to: key2,
          }
          await that.filterData(filter);
        },
      },
      {
        key: 2,
        type: "range-input",
        label: i18nText("Посещений"),
        async okRange(key1: any, key2: any) {
          let filter = {}
          filter = {
            count_from: key1,
            count_to: key2,
          }
          await that.filterData(filter);
        },
      },
      {
        key: 3,
        type: "datetimerange",
        label: i18nText("Есть записи"),
        async onChange(value: any) {
          let filter = {};
          if (value.length === 0) {
            filter = {
              exist_records_from: "0",
              exist_records_to: "0",
            };
          } else {
            filter = {
              exist_records_from: value[0].format("DD.MM.YYYY"),
              exist_records_to: value[1].format("DD.MM.YYYY"),
            };
          }
          await that.filterData(filter);
        },
      },
      {
        key: 4,
        type: "datetimerange",
        label: i18nText("Нет записей"),
        async onChange(value: any) {
          let filter = {};
          if (value.length === 0) {
            filter = {
              exist_records_from: "0",
              exist_records_to: "0",
            };
          } else {
            filter = {
              not_exist_records_from: value[0].format("DD.MM.YYYY"),
              not_exist_records_to: value[1].format("DD.MM.YYYY"),
            };
          }
          await that.filterData(filter);
        },
      },
      {
        key: 5,
        type: "sourceVuex",
        label: i18nText("Категория"),
        vuexSource: "category",
        storeVuexSource: "category",
        default_value: [i18nText("Не указано")],
        async onChange(value: any) {
          let filter = {};
          filter = {
            category_id: value,
          }
          await that.filterData(filter);
        },
      },
      {
        key: 6,
        type: "select",
        label: i18nText("Долг"),
        default_value: [i18nText("Не указано")],
        value: [
          {
            label: i18nText("Не указано"),
            key: "0",
          },
          {
            label: i18nText("Да"),
            key: "1",
          },
          {
            label: i18nText("Нет"),
            key: "2",
          },
        ],
        async onChange(value: any) {
          let filter = {};
          filter = {debt: value}
          await that.filterData(filter);
        },
      },
    );
    this.filter_load = true;
  }

  async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
    console.log('setFIlter>?>?>?>?>')
    await this.filterData(appFiltersStore.filter);
    await this.sortedData(by, {dataIndex: sort.dataIndex});
  }

  async clearFilter(clear: string): Promise<void> {
    await this.sortedData("desc", {dataIndex: "created_at"});
  }

  async clearAFilter(): Promise<void> {
    console.log("clearAFilter");
    this.proxyFilter = {
      salon_id: getStudioId(this),
    };
    for (let i of this.filtersData.filters) {
      i.default_value = [i18nText("Не указано")];
    }
    await this.sortedData("desc", {dataIndex: "created_at"});
  }
}
